module.exports = __webpack_public_path__ + "static/img/p3.64c1a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3.png
// module id = srf6
// module chunks = 0